// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/config/router.js#1 $
'use strict';

/**
* @ngdoc overview
* @name tcApp.module:tcRouter
* @description
* # tcRouter
* Angular Router configuration -- what should we load for particular $location values.
*/

angular
.module('tcApp')
.config(function($routeProvider) {
	$routeProvider
	.when('/Component/:componentName', {
		template: '<div class="componentWrapper"><tc-component component-name="resolveCtrl.componentName"'
			+ ' data="resolveCtrl.data">'
			+ '</tc-component>'
			+ '<tc-footer ng-if="!resolveCtrl.data.removeFooter"></tc-footer></div>',
		resolve: {
			componentData: function(WorkflowService) {
				return WorkflowService.getCachedOrNewData();
			},
		},
		controller: function($route, $templateCache, $log, componentData) {
			try {
				angular.fromJson(componentData.data);
			} catch (error) {
				$log.error('Invalid JSON string\n', componentData.data);
			}
			this.data = componentData.data;
			this.componentName = $route.current.params.componentName;
			
			// Remove any cached layout template that is an error.
			// So we always try to get a valid layout template (e.g. for questionnaires)
			var url = 'system.Router.cls?TLAYOUT=1&TCOMPONENT=' + this.componentName;
			if (angular.isDefined($route.current.params.CONTEXT)) {
				url = url + '&CONTEXT=' + $route.current.params.CONTEXT;
			}
			var cachedTemplate = $templateCache.get(url);
			if ((angular.isDefined(cachedTemplate)) && (angular.isFunction(cachedTemplate.indexOf)) &&
			(cachedTemplate.indexOf('ERROR') === 0)) {
				$templateCache.remove(url);
			}
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/Chart/:chartBookId?/:chartId?/:chartItem?', {
		template: '<tc-chart data="resolveCtrl.data"'
			+ ' id="tc_Chart"'
			+ '></tc-chart>',
		resolve: {
			chartData: function(WorkflowService) {
				return WorkflowService.getCachedOrNewData();
			},
		},
		controller: function($route, $log, chartData) {
			try {
				angular.fromJson(chartData.data);
			} catch (error) {
				$log.error('Invalid JSON string\n', chartData.data);
			}
			this.data = chartData.data;
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/ACN', {
		template: '<tc-acn data="resolveCtrl.data"'
			+ ' id="tc_ACN"'
			+ '></tc-acn>',
		resolve: {
			acnData: function($http, $route) {
				var params = $route.current.params;
				angular.extend(params, {IsACN: '1'});
				return $http.post('system.Router.cls?TACN=1', params);
			},
		},
		controller: function($route, $log, acnData) {
			try {
				angular.fromJson(acnData.data);
			} catch (error) {
				$log.error('Invalid JSON string\n', acnData.data);
			}
			this.data = acnData.data;
		},
		controllerAs: 'resolveCtrl'
	})

	.when('/ClinicalViewer', {
		// Must do POST to iframe because our url is > 4095 characters which is IE 11 limit 
		template: '<form action="{{ ::resolveCtrl.Url }}" method="POST" target="TRAK_main"'
			+ 'id="tc_ClincialViewer-form"></form>'
			+ '<iframe id="TRAK_main" name="TRAK_main" class="clinicalViewer"></iframe>',
		resolve: {
			clinicalViewerData: function($http, $route) {
				var params = $route.current.params;
				return $http.post('system.Router.cls?TCLINICALVIEWER=1', params);
			}
		},
		controller: function($log, $sce, clinicalViewerData, $window, $timeout, $rootScope) {
			$rootScope.$broadcast('SessionLockTimeout:startMonitor');
			try {
				angular.fromJson(clinicalViewerData);
			} catch (error) {
				$log.error('Invalid JSON string\n', clinicalViewerData.data);
			}
			this.Url = $sce.trustAsResourceUrl(clinicalViewerData.data.Url);
			$timeout(function() {
				var viewerForm = $window.document.getElementById('tc_ClincialViewer-form');
				viewerForm.submit();
			});
		},
		controllerAs: 'resolveCtrl',
	})
	.when('/websys.csp', {
		template: '<iframe id="TRAK_main" name="TRAK_main" class="legacyFrame" ng-src="{{resolveCtrl.legacyUrl}}"></iframe>'
			+ '<iframe id="TRAK_info" name="TRAK_info" class="legacyInfo"></iframe>',
		resolve: {
			bannerData: function(GlobalService, $http, $route) {
				$http.post('system.Router.cls', $route.current.params)
					.then(function(response) {
						if ((angular.isDefined(response.data)) && (angular.isDefined(response.data.bannerData))) {
							GlobalService.updateBannerData(response.data.bannerData);
						}
					});
			},
			legacyUrl: function($location, $rootScope) {
				$rootScope.$broadcast('SessionLockTimeout:startMonitor');
				return $location.url().substring(1);
			}
		},
		resolveAs: 'resolveCtrl'
	})
	.when('/Floorplan/:wardId?/:viewId?', {
		template: '<tc-floorplan data="resolveCtrl.data"'
			+ ' id="tc_Floorplan"'
			+ '></tc-floorplan>',
		resolve: {
			floorplanData: function($http, $route) {
				var params = $route.current.params;
				var wardId = ($route.current.params.wardId ? $route.current.params.wardId : '');
				var viewId = ($route.current.params.viewId ? $route.current.params.viewId : '');
				return $http.post('system.Router.cls?TFLOORPLAN=1' + ((wardId !== '') ? ('&TFLOORPLANWARDID=' + wardId) : '')
				+ ((viewId !== '') ? ('&TFLOORPLANVIEWID=' + viewId) : ''), params);
			},
		},
		controller: function($route, $log, floorplanData) {
			try {
				angular.fromJson(floorplanData.data);
			} catch (error) {
				$log.error('Invalid JSON string\n', floorplanData.data);
			}
			this.data = floorplanData.data;
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/PWB', {
		template: '<tc-pwb data="resolveCtrl.data"'
			+ ' id="tc_PWB"'
			+ '></tc-pwb>',
		resolve: {
			pwbData: function($http, $route) {
				var params = $route.current.params;
				return $http.post('system.Router.cls?TPWB=1', params);
			},
		},
		controller: function($route, $log, pwbData) {
			try {
				angular.fromJson(pwbData.data);
			} catch (error) {
				$log.error('Invalid JSON string\n', pwbData.data);
			}
			this.data = pwbData.data;
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/OrderEntry', {
		template: '<tc-order-entry data="resolveCtrl.data"'
			+ ' id="tc_OrderEntry"'
			+ '></tc-order-entry>',
		resolve: {
			orderentryData: function(WorkflowService) {
				return WorkflowService.getCachedOrNewData();
			},
		},
		controller: function($route, $log, orderentryData) {
			try {
				angular.fromJson(orderentryData.data);
			} catch (error) {
				$log.error('Invalid JSON string\n', orderentryData.data);
			}
			this.data = orderentryData.data;
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/LayoutEdit/:componentName/:modelClassName?', {
		template: '<tc-layout-edit '
			+ ' data="resolveCtrl.data"'
			+ '></tc-layout-edit>',
		resolve: {
			layoutData: function($http, $route) {
				var url = 'system.Router.cls?TLAYOUTEDIT=1&TCOMPONENT=' + $route.current.params.componentName;
				if ($route.current.params.modelClassName) {
					url = url + '&TMODELCLASSNAME=' + $route.current.params.modelClassName;
				}
				if (angular.isDefined($route.current.params.CONTEXT)) {
					url = url + '&CONTEXT=' + $route.current.params.CONTEXT;
				}
				
				return $http.post(url);
			},
		},
		controller: function($route, $log, layoutData) {
			try {
				angular.fromJson(layoutData.data);
			} catch (error) {
				$log.error('Invalid JSON string\n', layoutData.data);
			}
			this.data = layoutData.data;
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/Logon', {
		redirectTo: '/Component/SSUserLogon'
	})
	.when('/Logout', {
		template: '',
		resolve: {
			redirectData: function($http, $route, $window, GlobalService) {
				GlobalService.logoutHandler();
				return $http.post('system.Router.cls?TLOGOUT=1', $route.current.params)
					.then(function() {
						if (GlobalService.logonData.isExternalAuth) {
							if ((angular.isDefined(GlobalService.configuration.misc.externalAuthLogoutURL))
								&& (GlobalService.configuration.misc.externalAuthLogoutURL !== '')) {
								$window.location.href = GlobalService.configuration.misc.externalAuthLogoutURL;
							} else {
								// Redirect to the splash page for now, because the tab cannot be closed
								$window.location.href = ($window.location.href.split('/csp/system.Home')[0] + '/default.htm');
							}
						} else {
							var logonUrl = $window.location.href.split('#')[0];
							// On logout due to a session being reused, pass through the redirection for direct menus
							if (($route.current.params.Redirect)
								&& ($route.current.params.Redirect.indexOf('#/Direct/') === 0)) {
								logonUrl += ('?Redirect=' + encodeURIComponent($route.current.params.Redirect));
							}
							$window.location.href = logonUrl;
						}
					});
			}
		}
	})
	.when('/Workflow/:workflowId?', {
		template: '{{resolveCtrl.error.displayString}}',
		resolve: {
			redirectData: function($http, $route, $rootScope, $location, $log, GlobalService, WorkflowService) {
				var workflowId = $route.current.params.workflowId ? $route.current.params.workflowId : 'TMAIN';
				return $http.post('system.Router.cls?TWKFLI=0&TWKFL=' + workflowId,
								$route.current.params)
					.then(function(response) {
						if (response.data.error) {
							$log.error(response.data.error.displayString);
							return response.data;
						}
						if (response.data.location) {
							if (workflowId === 'TMAIN') {
								if ((response.data.sessionInfoReset) && (angular.isObject(response.data.sessionData))) {
									GlobalService.updateSessionData({data: response.data.sessionData});
								}
								$rootScope.$broadcast('tcMenu:MainMenuSelected');
							}
							if (!WorkflowService.urlHasDialogLevel(response.data.location)) {
								response.data.location = response.data.location 
									+ '&Dialog=' + ($route.current.params.Dialog ? $route.current.params.Dialog : 0);
							}
							$location.url(response.data.location).replace();
						}
					});
			},
		},
		controller: function(redirectData) {
			if (angular.isDefined(redirectData)) this.error = redirectData.error;
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/Worklist/:worklistName?', {
		template: '<tc-worklist data="resolveCtrl.data"'
			+ ' id="tc_Worklist"'
			+ '></tc-worklist>',
		resolve: {
			worklistData: function(WorkflowService, $route, $rootScope) {
				var worklistName = ($route.current.params.worklistName ? $route.current.params.worklistName : 'TMAIN');
				if (worklistName === 'TMAIN') $rootScope.$broadcast('tcMenu:MainMenuSelected');
				return WorkflowService.getCachedOrNewData();
			},
		},
		controller: function($route, $log, worklistData) {
			try {
				angular.fromJson(worklistData.data);
			} catch (error) {
				$log.error('Invalid JSON string\n', worklistData.data);
			}
			this.data = worklistData.data;
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/Direct/:menuName', {
		template: '{{resolveCtrl.error.displayString}}',
		resolve: {
			redirectData: function($http, $route, $rootScope, $location) {
				return $http.post('system.Router.cls?TDIRECT=1&TMENU=' + $route.current.params.menuName,
								$route.current.params)
					.then(function(response) {
						// Don't continue to direct menu where navigation has already occurred (e.g. redirected to logon)
						if (($location.tkReplaced) && ($location.path().indexOf('/Direct/') !== 0)) {
							return response.data;
						}
						if (response.data.location) {
							$rootScope.$broadcast('tcMenu:MainMenuSelected');
							$location.url(response.data.location).replace();
						}
						return response.data;
					});
			},
		},
		controller: function(redirectData) {
			this.error = redirectData.error;
		},
		controllerAs: 'resolveCtrl'
	})
	.when('/LogonSuccess', {
		template: '',
		resolveRedirectTo: function(GlobalService, $log, $route) {
			return GlobalService.loginHandler().then(function() {
				if ($route.current.params.Redirect) {
					return $route.current.params.Redirect;
				}
				if (angular.isDefined(GlobalService.logonData.startWorklist)) {
					return '/Worklist';
				} else {
					return '/Workflow';
				}
			}, function(error) {
				$log.error('LogonSuccess error: ', error);
			});
		}
	})
	.when('/Unlock', {
		resolve: {
			unlocked: function(GlobalService) {
				return GlobalService.unlockSession();
			}
		}
	})
	.when('/Back/:steps?', {
		resolve: {
			goBack: function($timeout, $route, $window, BreadcrumbService) {
				var steps = parseInt($route.current.params.steps, 10);
				steps = isNaN(steps) ? 2 : steps + 1;
				$timeout(function() {
					BreadcrumbService.navigateBack(steps);
				}, 0);
				return false;
			}
		}
	})
	.when('/CloseReload', {
		resolve: {
			goBack: function($timeout, WorkflowService, BreadcrumbService) {
				WorkflowService.isInCloseReload = true;
				$timeout(function() {
					BreadcrumbService.closeReload();
				}, 0);
				return false;
			}
		}
	})
	.when('/Reload', {
		resolve: {
			reload: function($timeout, WorkflowService, BreadcrumbService) {
				WorkflowService.isInReload = true;
				$timeout(function() {
					BreadcrumbService.navigateBack(1);
				}, 0);
				return false;
			}
		}
	})
	.when('/DisabledSession', {
		templateUrl: 'template/disabledSession/disabledSession.html',
		controller: function($rootScope, GlobalService) {
			var globalStrings = GlobalService.getGlobalStrings();
			this.errorMessage = (globalStrings['SESSION_EXPIRED_RESTART'] ? globalStrings['SESSION_EXPIRED_RESTART']
								: 'Session has timed out. Please start a new session.');
			GlobalService.detachUnloadHandler();
			
			// Prevent any further navigation on this session
			$rootScope.$on('$locationChangeStart', function preventNavigation($event) { //eslint-disable-line angular/on-watch
				if ($event) $event.preventDefault();
			});
		},
		controllerAs: '$ctrl'
	})
	.otherwise({
		resolveRedirectTo: function($window, $location) {
			// Only go to main page is TUID is defined
			var parameters = $location.search();
			if (angular.isDefined(parameters.TUID)) return '/Workflow';
			var logonUrl = '/Logon';
			if ($window.location.search.indexOf('?Redirect=') === 0) {
				logonUrl += $window.location.search.split('&')[0];
			}
			return logonUrl;
		}
	}
	);
});
